import mxgraph from 'mxgraph';

export let mxGraphClass;

export function initBooth(container) {
    const mxBasePath = `${process.env['VUE_APP_PUBLIC_PATH']}/mxgraph`;
    mxGraphClass = mxgraph({
        mxImageBasePath: `${mxBasePath}/images`,
        mxBasePath
    });
    const { mxClient, mxUtils, mxEvent, mxGraph } = mxGraphClass;
    if (!mxClient.isBrowserSupported()) {
        // Displays an error message if the browser is not supported.
        mxUtils.error('Browser is not supported!', 200, false);
    } else {
        mxEvent.disableContextMenu(container);
        const graph = new mxGraph(container);
        graph.centerZoom = false;
        graph.autoExtend = false;
        graph.setCellsCloneable(false);
        graph.setGridEnabled(false);
        return graph;
    }
}

export function setNewAdjustStyle(graph, fillColor) {
    mxGraphClass.mxConstants.HANDLE_FILLCOLOR = '#FEFEFE';
    mxGraphClass.mxConstants.HANDLE_STROKECOLOR = '#1976D2';
    mxGraphClass.mxConstants.VERTEX_SELECTION_COLOR = '#00a8ff';
    let vertexStyle = graph.getStylesheet()
        .getDefaultVertexStyle();
    graph.getStylesheet()
        .putDefaultVertexStyle({
            ...vertexStyle,
            'fillColor': fillColor || 'rgba(25, 118, 210, 0.1)'
        });
}

export function bindChangeEvent(graph, handler, bol) {
    if (bol) {
        graph.getModel().addListener(mxGraphClass.mxEvent.CHANGE, handler);
    } else {
        graph.getModel().removeListener(mxGraphClass.mxEvent.CHANGE, handler);
    }
}
